import { createFileRoute } from "@tanstack/react-router";
import { pageHead, rapportJsonLd } from "@/lib/seo";
import i18n from "@/i18n";

import { RapportPage } from "@/pages/rapport";

export const Route = createFileRoute("/rapport")({
  head: () => {
    const t = i18n.getFixedT("nl", "rapport");
    return pageHead({
      lang: "nl",
      pathWithoutLang: "/rapport",
      title: t("seo.title"),
      description: t("seo.description"),
      jsonLd: rapportJsonLd("nl"),
    });
  },
  component: RapportPage,
});
